require('./kitsSummary.scss');

// @ vendor
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @ commons
const { FormattedText } = require('core/i18n').i18n;
// @ helpers
const { getDetailsKit } = require('utilities/securityKit/securityKitHelper');
const { formatCurrency } = require('utilities/currencyHelper');
// @ constants
const { EURO_TEXT, SMS } = require('constants/index');

class KitsSummary extends PureComponent {

    renderSummay = () => {
        const { sets, referenceKits } = this.props;

        return sets.map((set, i) => {
            const details = getDetailsKit(set, referenceKits);
            const isSMS = details.typeKit === SMS;

            const titleClassName =  classNames('kits-summary__title', {
                'col-xs-9 col-md-10 col-lg-11': isSMS,
                'col-xs-7 col-md-8  col-lg-9': !isSMS
            })
            const kitClassName =  classNames('kits-summary__title kits-summary__title__align-right', {
                'col-xs-3 col-md-2 col-lg-1': isSMS,
                'col-xs-5 col-md-4 col-lg-3': !isSMS
            })

            return (
                <div key={i} className="row kits-summary__row">
                    <div className={titleClassName}>
                        <span className="kits-summary__title__initial">
                            {details.title.initial}
                        </span>
                        <span className="kits-summary__title__parenthesis">
                            {details.title.parenthesis}
                        </span>
                    </div>
                    <div className={kitClassName}>
                        <span>{details.typeKit + ' '}</span>
                        {details.showAmount &&
                            <div className="kits-summary__title__amount">
                                <FormattedText
                                    injectedStrings={details.amountKit}
                                    value={`securityKit-resumeKitCustom`}
                                />
                                <span>{formatCurrency(EURO_TEXT)}</span>
                            </div>
                        }
                    </div>
                </div>
            )
        })
    }

    render() {
        const { border } = this.props;
        const className =  classNames('kits-summary', {
            'kits-summary__border': border
        })
        return (
            <div className={className} >
                { this.renderSummay() }
            </div>
        );
    }
}

KitsSummary.propTypes = {
    border: PropTypes.bool,
    sets: PropTypes.object.isRequired,
    referenceKits: PropTypes.object.isRequired,
    fromSubmit: PropTypes.bool
};

KitsSummary.defaultProps = {
    border: true
}

export default KitsSummary;
